import React, { useContext, useEffect } from 'react'
import { CurrentUserContext } from '../../context/CurrentUserContext'

const Callback = () => {
  const { currentUser } = useContext(CurrentUserContext);

  useEffect(() => {
    if (currentUser) {
      const response = async () => {
        await fetch("https://api-j06q.onrender.com/api/instructor/get-status", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'Accept': 'application/json'
          },
          body: JSON.stringify({ currentUser })
        }).then((res) => {
          return res.json();
        }).then((res) => {
          console.log(res);
          localStorage.setItem("userRole", "Instructor")
          window.location.href = "/instructor";
          
        })
      }
      response();
    }
  },[currentUser])
  return (
    <div>
      <i className="fa-solid fa-spinner fa-spin"></i>
    </div>
  )
}

export default Callback